// Base api constants
const API_Protocol = `https://`;
const API_Location = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_URL !== 'qualentix.com' ? `:${process.env.REACT_APP_API_PORT}` : ''}`;
export const API_Url = `${API_Protocol}${API_Location}`;

// Deepseek AI Results api constants
export const API_DeepseekAllApplicationReviews = `${API_Url}/api/deepseek/fetch-all-deepseek-reviews`;
export const API_DeepseekCandidateApplicationReviews = `${API_Url}/api/deepseek/fetch-all-candidate-deepseek-reviews`;
export const API_DeepseekApplicationReview = `${API_Url}/api/deepseek/fetch-deepseek-review`;
export const API_RunDeepseekAiService = `${API_Url}/api/deepseek/run-deepseek-ai-service`;
export const API_RunDeepseekAiForJob = `${API_Url}/api/deepseek/run-deepseek-ai-for-job`;

// Google user api constants
export const API_GoogleUserInfo = `${API_Url}/api/auth/get-google-user`;

// Auth api constants
export const API_UserLogin = `${API_Url}/api/auth/login`;
export const API_UserLogout = `${API_Url}/api/auth/logout`;
export const API_RequestPasswordReset = `${API_Url}/api/auth/request-password-reset`;
export const API_ResetPassword = `${API_Url}/api/auth/reset-password`;
export const API_ChangePassword = `${API_Url}/api/auth/change-password`;
export const API_RegisterUser = `${API_Url}/api/auth/register`;
export const API_RestoreUserToken = `${API_Url}/api/auth/test-token`;
export const API_RefreshUserToken = `${API_Url}/api/auth/refresh-token`;
export const API_GetPendingUsers = `${API_Url}/api/auth/get-pending-users`;
export const API_ApproveUser = `${API_Url}/api/auth/approve-user`;
export const API_RejectUser = `${API_Url}/api/auth/reject-user`;
export const API_BanUser = `${API_Url}/api/auth/ban-user`;
export const API_GetRoleFromId = `${API_Url}/api/auth/get-role-from-id`;
export const API_GetBannedUsers = `${API_Url}/api/auth/get-banned-users`;
export const API_UnbanUser = `${API_Url}/api/auth/unban-user`;
export const API_GetActiveUsers = `${API_Url}/api/auth/get-active-users`;
export const API_LockUser = `${API_Url}/api/auth/lock-user`;
export const API_UnlockUser = `${API_Url}/api/auth/unlock-user`;
export const API_DeleteUser = `${API_Url}/api/auth/delete-user`;

// Landing page api constants
export const API_GetFinancialUserSummary = `${API_Url}/api/landing/financial/summary`;
export const API_GetManagerUserSummary = `${API_Url}/api/landing/manager/summary`;
export const API_GetAdminUserSummary = `${API_Url}/api/landing/admin/summary`;
export const API_GetContractorUserSummary = `${API_Url}/api/landing/contractor/summary`;
export const API_GetHiringManagerUserSummary = `${API_Url}/api/landing/hiring-manager/summary`;
export const API_GetInfoTechUserSummary = `${API_Url}/api/landing/it/summary`;

// Forms management api constants
export const API_GetActiveForms = `${API_Url}/api/forms/active-forms`;
export const API_GetArchivedForms = `${API_Url}/api/forms/archived-forms`;
export const API_GetUserActiveForms = `${API_Url}/api/forms/candidate-forms-active`;
export const API_GetUserArchiveForms = `${API_Url}/api/forms/candidate-forms-archived`;
export const API_UpdateFormStatus = `${API_Url}/api/forms/review-form`;
export const API_UploadFormToDrive = `${API_Url}/api/google-drive/upload-form`;
export const API_ReUploadFormToDrive = `${API_Url}/api/forms/resubmit`;
export const API_GetMissingRTRForms = `${API_Url}/api/forms/missing-right-to-represent`;
export const API_UploadRTRForm = `${API_Url}/api/google-drive/upload-right-to-represent`;

// Candidates api constants
export const API_GetCandidates = `${API_Url}/api/candidates/get-candidates`;
export const API_GetCandidateByID = `${API_Url}/api/candidates/get-candidate-by-ID`;
export const API_SearchCandidates = `${API_Url}/api/candidates/search-candidates`;
export const API_GetCandidateJobs = `${API_Url}/api/candidates/get-candidate-jobs`;
export const API_GetCandidateIdFromEmail = `${API_Url}/api/candidates/get-candidate-from-email`;
export const API_GetApplicantDetails = `${API_Url}/api/candidates/applicant-details`;
export const API_UpdateCandidateRemarks = `${API_Url}/api/candidates/update-remarks`;
export const API_UpdateCandidateDetails = `${API_Url}/api/candidates/update-candidate-details`;
export const API_PeopleProfileUpload = `${API_Url}/api/candidates/people-profile-upload`;
export const API_AddManualCandidate = `${API_Url}/api/candidates/add-new-manual-candidate`;

// Admin api constants
export const API_GetAdminIDByEmail = "/api/google-user/get-admin-id-by-email";

// Hiring Managers api constants
export const API_GetManagerJobs = `${API_Url}/api/hiring-managers/jobs/search`;
export const API_GetHiringManagerByEmail = `${API_Url}/api/hiring-managers/by-email/search`;

// Users api constants
export const API_UpdateCandidateInterviewStage = `${API_Url}/api/users/update-interview-status`;

// Applications api constants
export const API_GetApplicantJobs = `${API_Url}/api/applications/applicant-jobs`;
export const API_GetCandidateAppliedListingIds = `${API_Url}/api/applications/candidate-applied-job-listings`;
export const API_UpdateCandidateInterviewRemarks = `${API_Url}/api/applications/update-interview-remarks`;
export const API_GetJobApplications = `${API_Url}/api/applications/show-applications`;
export const API_CreateJobApplication = `${API_Url}/api/applications/create-job-application`;

// Jobs api constants
export const API_GetJob = `${API_Url}/api/jobs/get-job-by-id`;
export const API_GetJobs = `${API_Url}/api/jobs/get-all-jobs`;
export const API_UpdateJobStatus = `${API_Url}/api/jobs/update-job-status`;
export const API_GetJobContract = `${API_Url}/api/jobs/get-job-contract`;

// Skills api constants
export const API_GetAllDistinctSkills = `${API_Url}/api/skills/get-all-distinct-skills`;

// Persona api constants
export const API_GetJobPersonaDetails = `${API_Url}/api/personas/get-persona-and-skills`;
export const API_UpdateJobPersona = `${API_Url}/api/personas/update-job-persona`;
export const API_UpdatePersonaSkills = `${API_Url}/api/personas/update-persona-skills`;
export const API_GetAllPersonaContent = `${API_Url}/api/personas/get-all-personas-content`;
export const API_CreatePersona = `${API_Url}/api/personas/add-persona`;
export const API_UpdatePersona = `${API_Url}/api/personas/update-persona`;

// Employee api constant
export const API_GetEmployees = `${API_Url}/api/employees/get-employees`;

// Company api contants
export const API_GetCompanyIDByJob = `${API_Url}/api/companies/get-company-id-by-job`;
export const API_ListCompanies = `${API_Url}/api/companies/getCompanies`;
export const API_GetCompanyInfo = `${API_Url}/api/companies/getCompanyInfo`;
export const API_UpdateCompanyInfo = `${API_Url}/api/companies/updateCompany`;
export const API_CreateCompany = `${API_Url}/api/companies/create-company`;

// Learning Journal api constants
export const API_GetCandidateLearningJournals = `${API_Url}/api/learning-journals/get-candidate-journals`;
export const API_UpdateCandidateLearningJournal = `${API_Url}/api/learning-journals/update-candidate-journal`;
export const API_CreateLearningJournalEntry = `${API_Url}/api/learning-journals/create-learning-journal`;
export const API_GetAdminViewJournalEntries = `${API_Url}/api/learning-journals/get-admin-view-journal-entries`;

// Timesheets api constants
export const API_GetTimesheet = `${API_Url}/api/timesheets/get-timesheet`;
export const API_CreateTimesheet = `${API_Url}/api/timesheets/create-timesheet`;
export const API_GetAllTimesheets = `${API_Url}/api/timesheets/get-all-timesheets`;
export const API_GetCandidateTimesheetsForJournals = `${API_Url}/api/timesheets/get-candidate-timesheets-for-journals`;
export const API_SaveTimesheet = `${API_Url}/api/timesheets/save-timesheet`;
export const API_RejectTimesheet = `${API_Url}/api/timesheets/reject-timesheet`;
export const API_DeleteTimesheet = `${API_Url}/api/timesheets/delete`;

// User Profile api constants
export const API_UploadToImgHosting = `https://api.imgbb.com/1/upload`;
export const API_SetUserProfilePictureUrl = `${API_Url}/api/candidates/user-profile-picture-upload`; //NEED TO MOVE TO USERS AFTER USERS CLEANUP
export const API_UpdateUserName = `${API_Url}/api/candidates/update-user-name`; //NEED TO MOVE TO USERS AFTER USERS CLEANUP

// Google Drive api constants
export const API_UploadPhoto = `${API_Url}/api/drives/upload`;

// Project Details api constants
export const API_ListHMs = `${API_Url}/api/hiring-managers/getManagers`;
export const API_UpdateHMInfo = `${API_Url}/api/hiring-managers/updateManager`;
export const API_CreateHM = `${API_Url}/api/hiring-managers/createManager`;
export const API_GetHMInfo = `${API_Url}/api/hiring-managers/manager`;

// Job-Contract api constants
export const API_ListJobContracts = `${API_Url}/api/job-contracts/contracts`;
export const API_UpdateJobContract = `${API_Url}/api/job-contracts/update-contract`;
export const API_CreateJobContract = `${API_Url}/api/job-contracts/create-contract`;
export const API_CreateCompanyPosting = `${API_Url}/api/job-contracts/create-company-posting`;
export const API_UpdateCompanyPosting = `${API_Url}/api/job-contracts/update-company-posting`;
export const API_GetCompanyPosting = `${API_Url}/api/job-contracts/get-company-posting`;
export const API_GetExpiringJobContracts = `${API_Url}/api/job-contracts/get-expiring-contracts`;

// Leave Requests api constants
export const API_GetRegion = `${API_Url}/api/leave-requests/region`;
export const API_CreateLeaveRequest = `${API_Url}/api/leave-requests/create-leave-request`;
export const API_GetAllLeaveRequests = `${API_Url}/api/leave-requests/get-all-leave-requests`;
export const API_UpdateLeaveRequest = `${API_Url}/api/leave-requests/update-leave-request`;
export const API_DeleteLeaveRequest = `${API_Url}/api/leave-requests/delete-leave-request`;
export const API_GetApprovedLeaveRequests = `${API_Url}/api/leave-requests/get-approved-leave-requests`
export const API_ApproveLeaveRequest = `${API_Url}/api/leave-requests/approve`;
export const API_RejectLeaveRequest = `${API_Url}/api/leave-requests/reject`;
export const API_ResubmitLeaveRequest = `${API_Url}/api/leave-requests/resubmit`;
export const API_CheckDuplicateLeaveDates = `${API_Url}/api/leave-requests/check-duplicate-leave-dates`;

// External api constants
export const API_CanadianHolidays = 'https://canada-holidays.ca/api/v1/holidays';
export const API_AmericanHolidays = 'https://date.nager.at/api/v3/PublicHolidays';